<template>
  <div class="version">v{{ siteInfo.VersionNumber }}</div>
</template>

<script>
import siteInfo from '@/assets/SiteVersionInfo.json';
export default {
  data() {
    return {
      siteInfo: siteInfo,
    };
  },
};
</script>

<style scoped>
.version {
  color: white;
  font-size: 9px;
  position: fixed;
  bottom: 0;
  right: 40px;
}

@media only screen and (max-width: 960px) {
  .version {
    right: 20px;
  }
}
</style>
